// Dark product shell mock for the landing page preview section.
// Inline SVG only (Recharts stays scoped to the /demo route).
// Enrichment Centre view only. No vertical toggle.

const KPI_CHIPS = [
  { label: "New enquiries", value: "128", delta: "+12%" },
  { label: "Trials booked", value: "41", delta: "+8" },
  { label: "Trial show rate", value: "76%", delta: "+2 pts" },
  { label: "Enrolments", value: "19", delta: "+3" },
];

const FUNNEL_ROWS = [
  { label: "Enquiry", count: 128, pct: 100 },
  { label: "Qualified", count: 86, pct: 67 },
  { label: "Trial booked", count: 41, pct: 32 },
  { label: "Trial attended", count: 31, pct: 24 },
  { label: "Enrolled", count: 19, pct: 15 },
];

const QUEUE_ROWS = [
  { name: "Mdm Tan \u00b7 Emma", reason: "Trial attended, no decision yet", due: "Today" },
  { name: "Mr Rahman \u00b7 Isaac", reason: "Offer Sat 10:00 am trial slot", due: "Today" },
  { name: "Mdm Chua \u00b7 Kai", reason: "Term 3 renewal closing", due: "Tomorrow" },
];

const CHART_POINTS = "0,78 24,70 48,74 72,58 96,63 120,50 144,56 168,42 192,48 216,36 240,41 264,28 288,33 320,20";

export const DarkDashboardMock = () => (
  <div
    className="overflow-hidden rounded-2xl bg-[var(--navy-950)] p-4 shadow-[var(--shadow-lg)] sm:p-6"
    data-testid="dark-dashboard-mock"
    role="img"
    aria-label="Tuition centre enquiry management dashboard showing parent trial bookings and follow-up queue"
  >
    {/* chrome line */}
    <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
      <span className="rounded-md bg-[var(--navy-900)] px-3 py-1 text-[10px] font-semibold text-[var(--navy-200)]">
        app.enquiryops.com · Bright Minds Learning Lab
      </span>
      <span className="rounded-full border border-[var(--navy-800)] px-2.5 py-1 text-[10px] font-semibold text-[var(--navy-200)]">
        Demo data
      </span>
    </div>

    {/* KPI chips */}
    <div className="mb-3 grid grid-cols-2 gap-2 sm:grid-cols-4 sm:gap-3">
      {KPI_CHIPS.map((k) => (
        <div key={k.label} className="rounded-xl bg-[var(--navy-900)] p-3">
          <p className="text-[10px] font-medium text-[var(--navy-200)]">{k.label}</p>
          <div className="flex items-baseline gap-1.5">
            <span className="font-heading text-lg font-semibold tabular-nums text-[var(--paper)]">{k.value}</span>
            <span className="text-[10px] font-medium text-[var(--navy-200)]">{k.delta}</span>
          </div>
        </div>
      ))}
    </div>

    <div className="grid grid-cols-1 gap-3 lg:grid-cols-5">
      {/* chart panel */}
      <div className="rounded-xl bg-[var(--navy-900)] p-4 lg:col-span-3">
        <p className="mb-2 text-[11px] font-semibold text-[var(--navy-200)]">Enquiries, last 30 days</p>
        <svg viewBox="0 0 320 96" className="h-28 w-full" aria-hidden="true" preserveAspectRatio="none">
          <polyline
            points={CHART_POINTS}
            fill="none"
            stroke="var(--brand)"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      </div>

      {/* funnel panel */}
      <div className="rounded-xl bg-[var(--navy-900)] p-4 lg:col-span-2">
        <p className="mb-3 text-[11px] font-semibold text-[var(--navy-200)]">Parent conversion funnel</p>
        <div className="space-y-2.5">
          {FUNNEL_ROWS.map((row) => (
            <div key={row.label}>
              <div className="mb-1 flex items-center justify-between">
                <span className="text-[11px] font-medium text-[var(--paper)]">{row.label}</span>
                <span className="text-[10px] tabular-nums text-[var(--navy-200)]">{row.count}</span>
              </div>
              <div className="h-2 rounded-full bg-[var(--navy-800)]">
                <div className="h-2 rounded-full bg-[var(--navy-200)]" style={{ width: `${row.pct}%` }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>

    {/* follow-up queue */}
    <div className="mt-3 rounded-xl bg-[var(--navy-900)] p-4">
      <p className="mb-2 text-[11px] font-semibold text-[var(--navy-200)]">Follow-up queue</p>
      <div className="space-y-1">
        {QUEUE_ROWS.map((row) => (
          <div
            key={row.name}
            className="flex items-center justify-between gap-3 rounded-lg px-3 py-2 transition-colors duration-200 hover:bg-[var(--navy-800)]"
          >
            <div className="min-w-0">
              <p className="truncate text-xs font-medium text-[var(--paper)]">{row.name}</p>
              <p className="truncate text-[11px] text-[var(--navy-200)]">{row.reason}</p>
            </div>
            <span className="shrink-0 rounded-full border border-[var(--navy-800)] px-2 py-0.5 text-[10px] font-semibold text-[var(--navy-200)]">
              {row.due}
            </span>
          </div>
        ))}
      </div>
    </div>
  </div>
);
